module.exports = __webpack_public_path__ + "bs.svg?44a5b1bbdb1b2352539cb7e0a63e7746";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/bs.svg
// module id = 1014
// module chunks = 27